module.exports = __webpack_public_path__ + "img/convenience-3-image.adc991eb.jpg";